import { showLoading, hideLoading } from 'react-redux-loading'
import { getRFPContacts } from '../utils/api'

export const RECEIVE_CONTACTS = 'RECEIVE_CONTACTS'

export const receiveContacts = contacts => {
	return {
		type: RECEIVE_CONTACTS,
		contacts
	}
}

export const handleGetContacts = rfpId => {
	return async dispatch => {
		dispatch(showLoading());
		const contacts = await getRFPContacts(rfpId);
		dispatch(receiveContacts(contacts))
		return dispatch(hideLoading())
	}
}


// WEBPACK FOOTER //
// ./src/actions/contacts.js